<template>
  <div>
    <b-table striped small hover :items="issueVarsData">
      <template #cell(action)="data">
        <div class="text-right">
          <router-link :to="{ name: 'IssueVarDetails', params: {
            id: data.item.id
          }}">
            <b-icon icon="link45deg"></b-icon>
          </router-link>
          <a
            href="#"
            v-if="editMode"
            @click="editRow($event, data.item.action.issueVar)"
            ><b-icon icon="pencil"></b-icon
          ></a>
          <a href="#" v-if="editMode" @click="deleteRow($event, data.item.id)"><b-icon icon="trash"></b-icon></a>
        </div>
      </template>
      <template #cell(id)="data">
        <tdColUUID :value="data.item.id" />
      </template>
    </b-table>
    <b-col sm="4" md="3" v-if="showTotalLable">
      Total {{ issueVarsData.length }} {{ issueVarsData.length === 1 ? 'entry' : "entries" }} in table
    </b-col>
  </div>
</template>

<style scoped>
  * >>> th {
    font-size: 10px !important;
    text-transform: uppercase;
    color: #bbbbbb;
  }
</style>

<script>
  import tdColUUID from '@/components/tdColUUID.vue'

  export default {
    name: 'IssueVarTable',
    props: ['issueVars', 'editMode', 'showTotal'],
    data(){
      return {
        showTotalLable: this.showTotal ? this.showTotal : false
      }
    },
    components: {
      tdColUUID
    },
    computed: {
      issueVarsData(){
        return this.issueVars.map((issueVar, index) => {
          issueVar['_index'] = index;
          return {
            id: issueVar.id,
            form: issueVar.form,
            comment: issueVar.comment,
            ordering: issueVar.ordering,
            action: {
              issueVar: issueVar
            },
          }
        }).sort((a, b) => {
          if (a.ordering < b.ordering) return -1;
          if (a.ordering > b.ordering) return 1;
          return 0;
        })
      }
    },
    methods: {
      deleteRow(event, id){
        event.preventDefault()
        this.$emit('delete', id)
      },
      editRow(event, issueVar) {
        event.preventDefault();
        this.$emit("edit", issueVar);
      },
    }
  }
</script>
